import {createAction, props} from '@ngrx/store';

export const setNotification = createAction('[Notification Component] Set Notification', props<{ message: string }>() );
export const setSuccess = createAction('[Notification Component] Set Notification Success', props<{ message: string }>() );
export const setError = createAction('[Notification Component] Set Notification Error', props<{ message: string }>() );
export const closeNotification = createAction('[Notification Component] Close Notification');
